import React from 'react';
import { getLiveStreams } from '../Twitch';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
// @ts-ignore
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import { LiveStreams } from '../Twitch';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import LocalStorage from '../LocalStorage';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface FollowedStreamersState {
  liveStreams: LiveStreams[];
  filter: string;
}

const COLUMNS = [
  {
    dataField: 'id',
    text: 'id',
    hidden: true,
    searchable: false,
    sort: true,
    editable: false,
  },
  {
    dataField: 'username',
    text: 'Username',
    formatter: (cell: any) => (
      <>
        <a href={`https://twitch.tv/${cell}`} target='_blank'>{cell}</a>
        &nbsp;
        <OverlayTrigger
          key={cell}
          placement='top'
          overlay={
            <Tooltip id={`tooltip-top`}>
              Copy /raid to clipboard
            </Tooltip>
          }
        >
          <a href='#' onClick={
            () => { navigator.clipboard.writeText(`/raid @${cell}`)}
          }>📋</a>
        </OverlayTrigger>
      </>
    ),
    sort: true,
    editable: false,
  },
  {
    dataField: 'title',
    text: 'Title',
    sort: true,
    editable: false,
  },
  {
    dataField: 'uptime',
    text: 'Uptime',
    sort: true,
    editable: false,
  },
  {
    dataField: 'viewers',
    text: 'Viewers',
    searchable: false,
    sort: true,
    editable: false,
  },
  {
    dataField: 'tags',
    text: 'Tags',
    sort: true,
    formatter: (text: any) => {
      if (text)
        return text.split(' ')
          .map((tag: string) =>
            <>
              <span className='badge rounded-pill bg-primary'>{tag}</span>
              &nbsp;
            </>)
      return <></>
    },
  },
  {
    dataField: 'thumbnail',
    text: 'Thumbnail',
    searchable: true,
    editable: false,
    hidden: true
  },
  {
    dataField: 'notes',
    text: 'Notes',
    searchable: true,
    sort: true
  }
];

const DEFAULT_SORT = [
  {
    dataField: 'viewers',
    order: 'desc'
  }
];

//=============================================================================

export default class FollowedStreamers extends React.Component<{}, FollowedStreamersState> {

  private timeout!: NodeJS.Timeout;

  constructor(props: any) {
    super(props);
    this.state = {
      liveStreams: [],
      filter: ''
    };
    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  async getLiveStreams() {
    const streamers = await getLiveStreams();
    if (streamers && streamers.length) {
      this.setState({ liveStreams: streamers });
    }
  }

  componentDidMount() {
    this.getLiveStreams();
    this.timeout = setInterval(() => {
      console.log('refreshing streamers');
      this.getLiveStreams();
    }, 5000);
  }

  componentWillUnmount() {
    if (this.timeout) clearInterval(this.timeout);
  }

  onChange(event: any) {
    const value = event.target.value;
    this.setState({ filter: value });
  }

  save(oldValue: any, newValue: any, row: any, column: any) {
    LocalStorage.instance.set({
      id: row.id,
      tags: row.tags,
      notes: row.notes
    });
  }

  render() {
    const { liveStreams } = this.state;
    const { SearchBar } = Search;

    if (!liveStreams.length) {
      return (<>Loading</>);
    }

    const cellEdit = cellEditFactory({
      mode: 'click',
      blurToSave: true,
      afterSaveCell: this.save
    })

    return (
      <ToolkitProvider
        bootstrap4
        search
        keyField='id'
        data={liveStreams}
        columns={COLUMNS}
      >
        {
          props => (
            <div>
              <SearchBar
                { ...props.searchProps }
                placeholder={`Filter ${liveStreams.length} streams`}
              />
              <hr />
              <BootstrapTable
                { ...props.baseProps }
                cellEdit={ cellEdit }
              />
            </div>
          )
        }
      </ToolkitProvider>

    )

  }
}